import React from 'react'
import { Column } from '@antv/g2plot'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'

const Histograms = React.forwardRef((props: any, ref) => {
  const his = React.useRef<HTMLElement | string>('')
  const plot = React.useRef<Column>()

  React.useEffect(() => {
    //

    // eslint-disable-next-line react-hooks/exhaustive-deps
    plot.current = new Column(his.current, {
      ...props,
      autoFit: true,
      columnWidthRatio: 1,
      tooltip: {
        customContent: (title, data) => {
          if (data && data[0] && data[0].data && data[0].data) {
            const value = data[0].data
            const text = `${
              value.totalVariants
            } variants with ${value.yValue.toFixed(2)}% about(${value.start}-${
              value.end
            })`

            return text
          } else return ''
        },
        domStyles: {
          'g2-tooltip': {
            padding: '1rem',
            fontSize: '0.875rem',
            color: 'black'
          }
        }
      },
      color: (datum, defaultColor) => {
        return '#32B0C9'
      }
    })
  }, [])

  React.useEffect(() => {
    plot.current?.render()
  }, [])

  React.useImperativeHandle(ref, () => {
    return {
      plot
    }
  })

  return <Box ref={his} height={'220px'}></Box>
})
export default Histograms
